function add_selected_cls(){
    var array_filter = [];
    var filter_val = window.location.href;
    filter_val = filter_val.split("/").pop();
    filter_val = filter_val.split('+');
    array_filter = filter_val;
    $.each(array_filter, function(index, value){
      $(".filter_data li").each(function(){
        var coll_tag_name = $(this).attr('data-handle'); 
        if(coll_tag_name == value){
          $(this).addClass("tag-active");
        }
      });
    });
}
function tagfilter(e){
    var parent = $('.collection_filter');
    var filter = parent.find('.filter_wrapper');
    var cls_wc_group_data = '';     
    filter.each(function(){
      var filterType = $(this).find('.filter_data li');
      filterType.each(function(){         
        if($(this).hasClass('tag-active')){
          var handle = $(this).html();
          cls_wc_group_data += handle;
        }
      });
    }); 
}
function collection_filter(){
    var data_coll = $('.filter_data li').attr('data-collection'); 
    var shop_url = '/collections/' + data_coll;
    var activeTags = [];
    var form_url_id = '';
      $('.filter_data li.tag-active').each(function(){
        var selected_val = $(this).attr('data-handle');
        activeTags.push(selected_val);
      });
      $.unique(activeTags.sort());
  console.log(activeTags, shop_url)       
      form_url_id = shop_url+'/'+activeTags.join('+'); 
    $('.collection').load(form_url_id + ' .product_grid', function(){
      window.history.pushState({}, null, form_url_id);
      var length = $('.product_grid li').length;
      if(length < 1){
        $('.product_grid').append('<li class="not_availabel_text"><div class="heading_text"><h5>Sorry, there are no products.</h5></div></li>');
      }
      else{
        window.history.pushState({}, null, form_url_id);
      }
    });
  }
// $(document).ready(function(){
//     
//     add_selected_cls();
//     tagfilter();
// });


add_selected_cls();
$(document).on('click', '.filter_data li a', function(e){
  $(this).parent('li').toggleClass("tag-active");    
});

$('.apply_btn_div').click(function(){
  collection_filter();
});

$('.reset_filter').click(function(e){
      $('.filter_data li').removeClass('tag-active');
      collection_filter();
});
$(document).on('click', '.filter_button', function(){
  
  $('.filter_wrapper[data-id="'+$(this).attr('data-drawer')+'"]').addClass('open')
});
$(document).on('click', '.close_fltr', function(){
  $(this).parents('.filter_wrapper').removeClass('open');
})

